import React from "react";
import Image from "next/image";
import SafeHtml from "@/components/ui/SafeHtml";
import { toAbsoluteUrl } from "@/lib/toAbsoluteUrl";
import type { PostImageFields } from "@/types/acf";

export default function PostImage({ data }: { data: PostImageFields }) {
  const hide = (data as unknown as { hide?: boolean })?.hide;
  if (!data || hide) return null;

  const img = data.image && typeof data.image === "object" ? data.image : null;
  if (!img?.url || !img?.width || !img?.height) return null;

  const src = toAbsoluteUrl(img.url);
  if (!src) return null;

  const credit = data.credit ?? "";

  return (
    <figure className="w-full">
      {/* intrinsic sizing */}
      <Image
        src={src}
        alt={img.alt || ""}
        width={img.width}
        height={img.height}
        className="max-w-full h-auto"
        sizes="100vw"
      />

      {credit ? (
        <figcaption className="mt-2 text-sm opacity-70">
          <SafeHtml content={credit} />
        </figcaption>
      ) : null}
    </figure>
  );
}
